import { useTranslation } from 'react-i18next'

import { useGetHiddenWordsQuery } from 'store/api/yay/post'

import { Link } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import useGlobalConfirmBox from 'features/GlobalConfirmBox/hooks/useGlobalConfirmBox'

import Button from 'components/Button'

import { MODAL_MODE } from '../config'
import './style.scss'

const MuteKeywordsModal = () => {
  const { t } = useTranslation()
  const { generatePageModalUrl } = usePageModal()
  const { showErrorBox } = useGlobalConfirmBox()
  const { data, isLoading } = useGetHiddenWordsQuery(null)
  const hiddenWords = data?.hidden_words || []
  const isEmpty = !isLoading && hiddenWords.length === 0
  const isMaxed = hiddenWords.length === 20

  return (
    <div className="Modal__wrapper MuteKeywordsModal">
      <div className="Modal__header">
        <Link
          className="Modal__header__close Modal__header__close--back"
          to={generatePageModalUrl(MODAL_MODE.TIMELINE_FILTER)}
        />

        <h2 className="Modal__header__h2">{t('keyword_filter_page.title')}</h2>

        <div className="Modal__header__right">
          <Button
            buttonStyle="green"
            to={generatePageModalUrl(MODAL_MODE.KEYWORD_DETAILS)}
            onClick={(e) => {
              if (isMaxed) {
                e.preventDefault()
                showErrorBox({
                  title: t('keyword_filter_page.error.keyword_limit_title'),
                  content: t('keyword_filter_page.error.keyword_limit_message'),
                })
              }
            }}
          >
            {t('common.add')}
          </Button>
        </div>
      </div>

      <div className="Modal__body">
        {isEmpty && (
          <div className="MuteKeywordsModal__empty">
            <b>{t('keyword_filter_page.empty.title')}</b>
            <p>{t('keyword_filter_page.empty.description')}</p>
          </div>
        )}

        {hiddenWords.map((item) => (
          <div className="MuteKeywordsModal__word" key={item.id}>
            <p>{item.word}</p>
            <Link
              to={generatePageModalUrl(MODAL_MODE.KEYWORD_DETAILS, {
                id: item.id,
                keyword: item.word,
                context: item.context,
              })}
            >
              <img src="/images/icon-right.svg" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MuteKeywordsModal
